import usePermission from './usePermission';

export { usePermission };
